window.addEventListener("load", function(evt) {
//console.log(current_page_id)
});

let insymaContentlist = {
    _getData: async function(aURI) {
        try {
            const response = await fetch(aURI, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            });

            if (!response.ok) {
                console.log("Request fehlgeschlagen:", response.status);
                return {};
            }

            let data = await response.json();

            // Falls API manchmal String statt Objekt liefert
            if (typeof data !== "object") {
                data = JSON.parse(data);
            }

            return data;

        } catch (e) {
            console.log("Fehler beim Laden oder Parsen:", e);
            return {};
        }
    },
    _getTxtData: async function(aURI) {
        try {
            const response = await fetch(aURI, {
                method: "GET",
                headers: {
                    "Content-Type": "text/html; charset=utf-8"
                }
            });

            if (!response.ok) {
                console.log("Request fehlgeschlagen:", aURI, response.status);
                return "";
            }

            const text = await response.text();
            return text;

        } catch (e) {
            console.log("Fehler beim Laden:", e);
            return "";
        }
    },
    _loadContentList: async function (aParams) {
        //console.log("hi")
        let langpath = aParams.LangPath === "" ? "deu/" : aParams.LangPath;
        langpath = aParams.Preview === "True" ? "../" + langpath : aParams.LivePath + langpath;
        
        let jsonuri = langpath + "contentlist.json";
        let cache2 = new Date().getTime();
        jsonuri = jsonuri + "?ajax=" + cache2;
        
        let json = await insymaContentlist._getData(jsonuri);
        let html = "";
        if (typeof json.Data === "undefined") return false;

        let arr_param_types = aParams.Types.split("#");
        let sorting = "";let sortorder = "";
        for (let x = 0; x < json.Data.length; x++) {

            let object = json.Data[x];
            let vis0 = false, vis1 = false, vis2 = false, vis3 = false, vis4 = false, vis5 = false;
            let typesmatch = false;
            let str_obj_types = "#" + object.Types + "#";
            
            for (let i = 0; i < arr_param_types.length; i++) {
                if(str_obj_types.indexOf("#" + arr_param_types[i] + "#") > -1)
                    typesmatch = true;
            }
            
            vis0 = object.Types === "" || typesmatch || aParams.Types === "";
            vis1 = object.Tags === "" || object.Tags.indexOf(aParams.Tags) > -1 || aParams.Tags === "";
            vis2 = object.Themes === "" || object.Themes.indexOf(aParams.Themes) > -1 || aParams.Themes === "";
            vis4 = object.Origin === "" || object.Origin.indexOf(aParams.Origin) > -1 || aParams.Origin === "";
            vis5 = true;
            
            if (object.Types === "News" || object.Types === "Blog" || object.Types === "FAQ") {
                vis3 = false;
                let vis3_t = false, vis3_f = false;
                let now = new Date();
                now = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
                
                if (object.DateValidTo !== "") {
                    let arr_at = object.DateValidTo.split(".");
                    let t = new Date(arr_at[2], parseInt(arr_at[1]) - 1, arr_at[0]);

                    if ((aParams.Archive === "" && now < t) || (aParams.Archive !== "" && now > t)) {
                        vis3_t = true;
                    }
                } else {
                    vis3_t = true;
                }
                
                if(object.DateValidFrom !== "") {
                    let arr_from = object.DateValidFrom.split(".");
                    let f = new Date(arr_from[2], parseInt(arr_from[1]) - 1, arr_from[0]);
                    if(now >= f) 
                        vis3_f = true;
                } else {
                    vis3_f = true;
                }
                
                vis3 = vis3_f && vis3_t && aParams.Archive === "";
            }
            
            
            if(aParams.SortingValue !== "") {
                let sortvalue = aParams.SortingValue;
                sortorder = aParams.SortingType;
                if(sortvalue === "DateContent") {
                    if(object["DateContent"] !== "") {
                        let arr_sort = object["DateContent"].split(".");
                        let mon = parseInt(arr_sort[1]) - 1;
                        mon = mon < 10 ? "0" + mon : mon;
                        sorting = arr_sort[2] + mon + arr_sort[0];
                    }
                } else {
                    sorting = object.Title;
                }
            } else {
                sorting = "zzzzzzzz";
            }
            
            let art = "div";
            let css = "card card-linked border-0 rounded";
            //console.log(object.Title + "::" + object.Types + "::" + vis0 + "&&" + vis1 + "&&" + vis2 + "&&" + vis3 + "&&" + vis4 + "&&" + vis5)
            if (vis0 && vis1 && vis2 && vis3 && vis4 && vis5) {
                let uri = aParams.Preview === "True" ? object.URL_Prev_Snippet : object.URL_Live_Snippet;
                html += "<" + art + " class='" + css + "' data-val='" + sorting + "'>" + await insymaContentlist._getTxtData(uri) + "</" + art + ">";
            }
        }
        //console.log(html)
        document.querySelector("." + aParams.elem + " .ConListEntries").innerHTML = html;
        
        document.querySelectorAll("." + aParams.elem + " .ConListEntries .content-property-empty").forEach(elem => {
            elem.parentNode.parentNode.remove();
        });
        
        document.querySelectorAll("." + aParams.elem + " .ConListEntries .card").forEach(card => {
            if(card.querySelectorAll("a").length === 0)
                card.classList.remove("card-linked");
        });
        
        insymaContentlist._setContentListSorting(aParams, sortorder);
        insymaContentlist._setContentListNumbers(aParams);
        if (aParams.Paging !== "") {
             insymaContentlist._setContentListPaging(aParams);
        }
    },
    _setContentListSorting: function(aParams, sortorder){
        const el = document.querySelector("." + aParams.elem);
        const lis = el.querySelector("div.ConListEntries").children;
        const lisArray = Array.from(lis);
        tinysort(lis,{ attr: 'data-val', order: sortorder});
    },
    _setContentListNumbers: function(aParams){
        if (aParams.PageSize !== "0" && aParams.PageSize !== "") {
            const el = document.querySelector("." + aParams.elem);
            const lis = el.querySelector("div.ConListEntries").children;
            const pageSize = parseInt(aParams.PageSize);

            Array.from(lis).forEach((li, i) => {
                if (i >= pageSize) {
                    li.style.display = 'none';
                }
            });
        }
    },
    _setContentListLogic: function (aParams) {
        if (typeof hideDom !== 'undefined') {
            hideDom.hideList('div.pageContentList', '.ConListEntries', 'div[data-obj-id]');
        }

        document.querySelectorAll(".PartEvents .iconmore").forEach(icon => {
            icon.addEventListener('click', function() {
                this.style.display = 'none';
                this.nextElementSibling.style.display = 'block';
                this.parentElement.nextElementSibling.style.display = 'block';
            });
        });

        document.querySelectorAll(".PartEvents .iconless").forEach(icon => {
            icon.addEventListener('click', function() {
                this.style.display = 'none';
                this.previousElementSibling.style.display = 'block';
                this.parentElement.nextElementSibling.style.display = 'none';
            });
        });

        const el = document.querySelector("." + aParams.elem);
        const lis = el.querySelector("div.ConListEntries").children;

        if (aParams.archive !== "") {
            document.querySelector("div.pager").previousElementSibling.style.display = 'none';
        }

        let imgpath = "";
        if (document.URL.indexOf("test.contentupdate.net") > -1) {
            imgpath = "/Gebaeudetechnik_BLAG";
        }

        if (el.querySelector("ul.list-news") || el.querySelector("ul.list-jobs")) {
            Array.from(lis).forEach(li => {
                const dt = li.querySelector(".con-time").getAttribute("datetime");
                li.setAttribute("data-time", dt ? dt.replace(/-/g, "") : "00000000");

                const img = li.querySelector("figure");
                if (img) {
                    const _img = getComputedStyle(img).backgroundImage;
                    if (_img) {
                        img.style.backgroundImage = _img.replace("https://test.contentupdate.net", imgpath);
                    }
                }
            });

            if (aParams.archive === "") {
                Array.from(lis).sort((a, b) => b.getAttribute('data-time').localeCompare(a.getAttribute('data-time')));
            } else {
                Array.from(lis).sort((a, b) => a.getAttribute('data-time').localeCompare(b.getAttribute('data-time')));
                el.querySelectorAll("button").forEach(btn => btn.style.display = 'none');
            }
        } else if (el.querySelector("div.cards-con-news") || el.querySelector("div.cards-con-jobs")) {
            Array.from(lis).forEach(li => {
                const dt = li.querySelector(".con-time").getAttribute("datetime");
                li.setAttribute("data-time", dt ? dt.replace(/-/g, "") : "00000000");
            });

            if (aParams.archive === "") {
                Array.from(lis).sort((a, b) => b.getAttribute('data-time').localeCompare(a.getAttribute('data-time')));
            } else {
                Array.from(lis).sort((a, b) => a.getAttribute('data-time').localeCompare(b.getAttribute('data-time')));
                el.querySelectorAll("button").forEach(btn => btn.style.display = 'none');
            }
        }

        if (aParams.backv !== "" && !el.querySelector("div.EventsKalender")) {
            Array.from(lis).forEach(li => {
                let htm = "<span class='Item-Action'>";
                if (li.querySelector("div.ItemGallery")) {
                    htm += `<a class='icon icon-gallery' href='${li.getAttribute("data-link")}' title=''></a>`;
                }
                htm += `<a class='icon icon-detailpage' href='${li.getAttribute("data-link")}' title=''></a></span>`;
                li.querySelector(".iconmore").style.display = 'none';
                li.querySelector(".iconless").insertAdjacentHTML('afterend', htm);
            });
        }

        document.querySelectorAll(".ConAnmeldung").forEach(anmeldung => {
            anmeldung.addEventListener('click', function() {
                const div = document.createElement('div');
                const _id = this.getAttribute("data-id");
                const _mail = this.getAttribute("data-mail");
                const parentLi = this.closest('li');

                fetch(this.getAttribute("data-uri"))
                    .then(response => response.text())
                    .then(data => {
                        div.innerHTML = data;
                        const options = {
                            type: 'content',
                            class: 'content',
                            content: div,
                            w: '800px',
                            h: 'auto'
                        };
                        document.querySelector("div#insymaOverlayContent").innerHTML = "";
                        Iob.openOverlay();
                        Iob.openContent(options);
                        window.scrollTo({top: 100, behavior: 'smooth'});

                        const textarea = document.querySelector("#insymaOverlayContent textarea");
                        let htm = `${parentLi.querySelector(".Item-Time").textContent}\n`;
                        htm += `${parentLi.querySelector(".Item-Title > small").textContent.replace("<br>", "\n")}\n`;
                        htm += `${parentLi.querySelector(".Item-Title > span").textContent.replace("<br>", "\n")}\n`;
                        textarea.value = htm;

                        htm = `<input type='hidden' name='SaveToList' value='${_id}' />`;
                        htm += `<input type='hidden' name='Recipient' value='${insymaUtil.decodeMail(_mail.replace(/__/g, ".").replace(/--/g, "@")).replace("_L", "")}' />`;
                        document.querySelector("#Message").insertAdjacentHTML('beforebegin', htm);

                        document.querySelectorAll("select, input").forEach(el => {
                            if (!el.classList.contains("noUniform")) {
                                // Assuming 'uniform' is a function that styles form elements
                                uniform(el);
                            }
                        });
                    });
            });
        });

        const span = document.querySelectorAll("div.ConListSorting > span");
        document.querySelector("div.ConListSorting > span.Item-Time").addEventListener('click', function() {
            Array.from(lis).sort((a, b) => a.getAttribute('data-time').localeCompare(b.getAttribute('data-time')));
            span.forEach(s => s.classList.remove("active"));
            this.classList.add("active");
        });

        document.querySelector("div.ConListSorting > span.Item-Location").addEventListener('click', function() {
            Array.from(lis).sort((a, b) => a.getAttribute('data-loc').localeCompare(b.getAttribute('data-loc')));
            span.forEach(s => s.classList.remove("active"));
            this.classList.add("active");
        });

        document.querySelector("div.ConListSorting > span.Item-Title").addEventListener('click', function() {
            Array.from(lis).sort((a, b) => a.getAttribute('data-reg').localeCompare(b.getAttribute('data-reg')));
            span.forEach(s => s.classList.remove("active"));
            this.classList.add("active");
        });

        Iob.grabStuff();

        document.querySelectorAll(".icon-gallery").forEach(icon => {
            icon.addEventListener('click', function(e) {
                this.closest(".Item-Header").nextElementSibling.querySelector(".imagelink").click();
                e.preventDefault();
                return false;
            });
        });
    },
    _setContentListPaging: function (aParams) {
        const el = document.querySelector("." + aParams.elem);
        const c = parseInt(aParams.PageSize);
        const ul = el.querySelector("div.ConListEntries");
        const lis = ul.children;
        console.log(lis.length);

        Array.from(lis).forEach((li, i) => {
            if (i >= c && c != 0) {
                li.style.display = 'none';
            }
            li.setAttribute("data-count", Math.ceil((i + 1) / c));
        });

        const anz = lis.length;
        const erg = Math.ceil(anz / c);

        if (anz > c) {
            let htm = "";
            for (let i = 1; i <= erg; i++) {
                let css = i === 1 ? "active" : "";
                htm += `<a class='page-link ${css}' href='Javascript:void(0)' data-page='${i}'>${i}</a>`;
            }
            el.querySelector(".pagecount").innerHTML = htm;

            insymaContentlist._displayPrevs(1, erg, el);

            const span = el.querySelectorAll(".pagecount > a");
            span.forEach(a => {
                a.addEventListener('click', function() {
                    if (!this.classList.contains("active")) {
                        span.forEach(s => s.classList.remove("active"));
                        this.classList.add("active");
                        Array.from(ul.children).forEach(child => child.style.display = 'none');
                        ul.querySelectorAll(`div[data-count='${this.getAttribute("data-page")}']`)
                          .forEach(div => div.style.display = '');
                        insymaContentlist._displayPrevs(parseInt(this.getAttribute("data-page")), erg, el);
                        insymaContentlist._displayNexts(parseInt(this.getAttribute("data-page")), erg, el);
                    }
                });
            });

            el.querySelectorAll(".page-item").forEach(item => item.style.display = 'none');
            el.querySelectorAll(".page-item > a").forEach(a => {
                a.addEventListener('click', function() {
                    // Uncomment and implement if needed:
                    // insymaContentlist._switchPaging(this, erg, span, ul, el);
                });
            });
        } else {
            document.querySelector(".pager").style.display = 'none';
        }
    },
    _switchPaging: function (aEl, aMax, aSpan, ul, el) {
        const activeElement = document.querySelector(".active");
        let curr = parseInt(activeElement.getAttribute("data-page"));

        if (aEl.classList.contains("first")) {
            curr = 1;
        }
        if (aEl.classList.contains("prev")) {
            if (curr > 1) curr = curr - 1;
        }
        if (aEl.classList.contains("next")) {
            if (curr < aMax) curr = curr + 1;
        }
        if (aEl.classList.contains("last")) {
            curr = aMax;
        }

        aSpan.forEach(span => span.classList.remove("active"));
        document.querySelector(`span.pagecount a[data-page="${curr}"]`).classList.add("active");

        ul.querySelectorAll("li").forEach(li => li.style.display = "none");
        ul.querySelector(`li[data-count="${curr}"]`).style.display = "block";

        insymaContentlist._displayPrevs(parseInt(curr), aMax, el);
        insymaContentlist._displayNexts(parseInt(curr), aMax, el);
    },
    _displayPrevs: function (aId, aMax, aEl) {
        const fastRewind = aEl.querySelector(".item--fast-rewind");
        const skipPrevious = aEl.querySelector(".item--skip-previous");

        if (aId == 1) {
            fastRewind.style.display = "none";
            skipPrevious.style.display = "none";
        } else {
            fastRewind.style.display = "block";
            skipPrevious.style.display = "block";
        }
    },
    _displayNexts: function (aId, aMax, aEl) {
        const fastForward = aEl.querySelector(".item--fast-forward");
        const skipNext = aEl.querySelector(".item--skip-next");

        if (aId == aMax) {
            fastForward.style.display = "none";
            skipNext.style.display = "none";
        } else {
            fastForward.style.display = "block";
            skipNext.style.display = "block";
        }
    }
}
